// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Data from "common/src/data/Data.bs.js";
import * as React from "react";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as AugmentImage from "common/src/tft-static/AugmentImage.bs.js";
import * as UnitImageExtended from "common/src/tft-static/UnitImageExtended.bs.js";

function PlShortMatchSummary(Props) {
  var hp = Props.hp;
  var augments = hp.info.augments;
  return React.createElement("div", undefined, React.createElement("div", {
                  className: "flex items-center py-[2px]"
                }, augments !== undefined ? React.createElement("div", {
                        className: "flex items-center pr-2"
                      }, Belt_Array.mapWithIndex(augments, (function (idx, id) {
                              return React.createElement("div", {
                                          key: String(idx),
                                          className: "flex-shrink-0" + (
                                            idx === 0 ? "" : " pl-1"
                                          )
                                        }, React.createElement(AugmentImage.make, {
                                              augId: Data.encodeAugmentId(id),
                                              size: 32
                                            }));
                            }))) : null, Belt_Array.mapWithIndex(Belt_Array.keep(hp.info.units, (function (u) {
                            return ![
                                      "TFT_TrainingDummy",
                                      "TFT7_TrainerDragon",
                                      "TFT7_JadeStatue"
                                    ].includes(u.id);
                          })), (function (idx, u) {
                        return React.createElement("div", {
                                    className: idx === 0 ? "" : "pl-1"
                                  }, React.createElement(UnitImageExtended.make, {
                                        size: 37,
                                        unitId: u.id,
                                        starLevel: u.tier,
                                        items: Belt_Array.map(u.items, (function (prim) {
                                                return String(prim);
                                              }))
                                      }));
                      }))));
}

var make = PlShortMatchSummary;

export {
  make ,
  
}
/* Data Not a pure module */
